export default __webpack_public_path__ + "static/media/geofence.e328b1e5.svg";